export default __webpack_public_path__ + "static/media/baseball-player-select-mobile1.8b05a816.png";